import router from 'next/router'

export const isDebtCalcError = (monthlyPayment?: number): boolean => {
	if (!monthlyPayment) return true
	return Math.sign(monthlyPayment) === -1 || isNaN(monthlyPayment)
}

export const redirectToApply = (value: number): void => {
	const query = {
		productType: 'loan',
		loanPurpose: 'debt_consolidation',
		loanAmount: value
	}

	router.push({ pathname: '/products/loans', query })
}
